import { render } from "./UiAnimation.vue?vue&type=template&id=63cae850"
import script from "./UiAnimation.vue?vue&type=script&lang=js"
export * from "./UiAnimation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__